// extracted by mini-css-extract-plugin
export default {"cardContainer":"featured-events-carousel_cardContainer__EoKlo","image":"featured-events-carousel_image__ndIu9"};